import React from 'react';

const Header = () => {
  return <div className="border-b border-gray-200 p-2">
    <h1 className="text-6xl">Tree Generator</h1>
    <p>Experimenting with the wave collaps function</p>
  </div>
};

export default Header;